export const environment = {
    production: false,
    gaMeasurementId: '', //'G-FGE155RN1G'
    redirectToNewSiteLocationCodes:["4870","4881","4253","4725","4052","4289","4346","4019","4195","4505","4606","4339","4219","4632","4262","4413","4358","4593","4747","4056","4396","4167","4440","4389","4205","4446","4185","4851","4672","4740","4093","4325","4166","4089","4053","4183","4395","4719","4132","4506","4144","4299","4047","4684","4150","4228","4215","4323","4008","4298","4000","4351","4065","4031","4880","4385","4102","4125","4548","4184","4442"],
    redirectNewSiteLink: 'https://app.booking.dev.merrymaids.io',
    redirectNewSitePercentage: 100,
    gtmId: '',
    gtmAuth: '',
    gtmPreview: '',
    baseUrl: 'https://api.ecommerce.dev.merrymaids.io',
    enableDebugMode: true,
    appInsightsConnectionString:
        'InstrumentationKey=2e28f17b-28a1-4661-9bee-b797fe03344e;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=e6326f5b-7fa1-46f5-89dc-9ddcfb5221f3',
};
